export const unmask = (str: string): string =>
  str && str.replace(/[-)./(+ ]/g, '');
